import { RainCutVariant } from "@biz/definitions/ArticleDefinitions";
import { SojoWoodType } from "@biz/definitions/LoungeDefinitions";

// 73 ... Auszug angleichen ... nirgends verwendet?
export type BeosVarianten = Partial<{
  "6": "3-ECK" | "4-ECK" | "5-ECK" | "6-ECK";
  "41": string; // 41 ... Segelfarbe
  "42": "KURZ" | "LANG" | SojoWoodType; // Raffhalter, "Sojo Holzart"
  "50": RainCutVariant;
  "72": string; // 72 ... höchster Punkt
  // "75": TwistingSetVariant; // 75 ... Verspannungsset
  "68": "WAND" | "MAST"; // Wand für Wand/Wand sonst MAST (Wand/Mast oder Mast/Mast)
  "81": number; // 81 ... pylonCount
  // rainCut: boolean;
  "40": string; // "4X5", ...  standardSize
}>;

function isLongTieBack(length: number): boolean {
  return length > 1.005;
}

export function getTieBackVariant(length: number): "KURZ" | "LANG" {
  return isLongTieBack(length) ? "LANG" : "KURZ";
}

export function mergeBeosVarianten(a: BeosVarianten | undefined, b: BeosVarianten | undefined, c?: BeosVarianten | undefined): BeosVarianten | undefined {
  const merged = {
    ...a,
    ...b,
    ...c
  }
  if (Object.keys(merged).length > 0)
    return merged;
  return undefined;
}